import PageLayout from "../../components/feature/PageLayout";
import InfoPageHero from "../../components/feature/InfoPageHero";
import InfoPageFinalCTA from "../../components/feature/InfoPageFinalCTA";
import InfoPageFooter from "../../components/feature/InfoPageFooter";
import AccessSection from "./components/AccessSection";
import TipsSection from "./components/TipsSection";
import { useAccessData } from "../../lib/useMockData";

export default function Access() {
  const { heroData, finalCTA } = useAccessData();
  return (
    <PageLayout>
      <InfoPageHero
        label="ACCESS"
        title={heroData.title}
        subtitle={heroData.subtitle}
        image={heroData.image}
        alt="ヘリポートまでのアクセス"
      />
      <AccessSection />
      <TipsSection />
      <InfoPageFinalCTA
        title={finalCTA.title}
        subtitle={finalCTA.subtitle}
        ctas={finalCTA.ctas}
      />
      <InfoPageFooter />
    </PageLayout>
  );
}
